"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineMediaQueriesWithAnd = void 0;
/**
 * Combines multiple media queries into one
 * The parts of the created media query are separated by the 'and' logical operator
 * @param {...string} mediaQueries
 * @returns {string}
 */
var combineMediaQueriesWithAnd = exports.combineMediaQueriesWithAnd = function combineMediaQueriesWithAnd() {
  for (var _len = arguments.length, mediaQueries = new Array(_len), _key = 0; _key < _len; _key++) {
    mediaQueries[_key] = arguments[_key];
  }
  return "@media ".concat(mediaQueries.map(function (str) {
    return str.replace('@media ', '');
  }).join(' and '));
};